import { registerNavigateAwayGuard } from "@/router/onNavigateAway.guard";
import store from "@/store";
import { PAGE_FIRST_SEGMENT } from "@/apps/page/page.routes";

registerNavigateAwayGuard({
    segment: PAGE_FIRST_SEGMENT,
    async onDropChanges() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        await store.dispatch("page/projects/loadProject", store.state.page.page.uuid);
    },
    async onSaveChanges() {
        await store.dispatch("page/projects/saveSnapshot");
    },
});
